
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/cce19d06f32f8fbce40a615e6a32ab50.jpg"
          alt="Construcción profesional"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full mb-8">
          <i className="ri-shield-check-line text-teal-600"></i>
          <span className="text-sm font-medium text-gray-800">Profesionales Certificados</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          CONSTRUCCIÓN<br />
          OBRAS Y REFORMAS<br />
          DE CALIDAD
        </h1>

        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          Transformamos espacios con más de 15 años de experiencia. Desde reformas integrales hasta proyectos de construcción completos, garantizamos calidad y profesionalidad en cada detalle.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a 
            href="tel:628752701"
            className="flex items-center gap-2 px-8 py-4 bg-black text-white text-base font-medium rounded-full hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            628 752 701
          </a>
          <a 
            href="https://wa.me/34628752701"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-8 py-4 bg-transparent border-2 border-white text-white text-base font-medium rounded-full hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-green-400"></i>
            WhatsApp
          </a>
        </div>

        <div className="max-w-5xl mx-auto">
          <img 
            src="https://readdy.ai/api/search-image?query=Beautifully%20renovated%20modern%20interior%20space%20showing%20completed%20construction%20work%2C%20elegant%20kitchen%20or%20living%20room%20with%20contemporary%20design%2C%20natural%20lighting%2C%20high-quality%20finishes%2C%20wooden%20floors%2C%20clean%20lines%2C%20professional%20interior%20photography%20showcasing%20craftsmanship%20and%20attention%20to%20detail&width=1200&height=400&seq=hero-project-showcase&orientation=landscape"
            alt="Proyecto terminado"
            className="w-full h-96 object-cover rounded-3xl shadow-2xl"
          />
        </div>
      </div>
    </section>
  );
}
